import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  fetchMe,
  updateUser,
} from '../../actions';

class General extends Component {
  constructor(props) {
    super(props);
    this.state = {
      emailOnLogin: false,
      pristine: true,
      newsletter: false,
    };
    this.handleNewsletterChange = this.handleNewsletterChange.bind(this);
  }

  componentDidMount() {
    const { user } = this.props;

    let emailOnLogin;
    if (user && user.me && user.me.flags && user.me.flags.emailOnLogin) {
      emailOnLogin = user.me.flags.emailOnLogin;
    }

    let newsletter;
    if (user && user.me && user.me.flags && user.me.flags.optInNewsletter) {
      newsletter = user.me.flags.optInNewsletter;
    }

    this.setState({
      emailOnLogin,
      newsletter,
    });
  }

  handleEmailOnLoginChange() {
    const { dispatch, user } = this.props;
    const { emailOnLogin } = this.state;

    const data = {
      emailOnLogin: !emailOnLogin,
    };

    dispatch(updateUser(data)).then((res) => {
      if (res) dispatch(fetchMe());
    });

    this.setState({ emailOnLogin: !emailOnLogin, pristine: true });
  }

  handleNewsletterChange() {
    const { dispatch, user } = this.props;
    const { newsletter } = this.state;

    const data = {
      newsletter: !newsletter
    }

    dispatch(updateUser(data)).then((res) => {
      if (res) dispatch(fetchMe());
    });

    this.setState({ newsletter: !newsletter, pristine: true });

  }

  render() {
    const { emailOnLogin, pristine } = this.state;

    return (
      <div className="cell panel v2 small-12 medium-12 large-12">
        <div className="panel-label">
          Notifications
        </div>
        <div className="grid-x">
          <div className="cell small-12 medium-12 large-12">
            <div className="grid-x align-middle">
              <div className="cell small-6 medium-6 large-6">
                <div className="">Newsletter</div>
              </div>
              <div className="cell small-6 medium-6 large-6 flex-end">
                <div className="">
                  <div
                    onClick={() => this.handleNewsletterChange()}
                    className={this.state.newsletter ? 'vlt-switch on' : 'vlt-switch off'}
                    >
                    <div></div>
                    <div></div>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="grid-x align-middle">
              <div className="cell small-6 medium-6 large-6">
                <div className="gf-label">Receive Email on Login</div>
              </div>
              <div className="cell small-6 medium-6 large-6 flex-end">
                <div className="">
                  <div
                    onClick={() => this.handleEmailOnLoginChange()}
                    className={emailOnLogin ? 'vlt-switch on' : 'vlt-switch off'}
                    >
                    <div></div>
                    <div></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
});

export default connect(mapStateToProps)(General);
